"use client";

import { useEffect, useState } from "react";
import { formatIST } from "@/lib/timezone";
import { MORNING_FINALIZE_HOUR } from "@/lib/timezone";

export function IstClock() {
  const [now, setNow] = useState<Date | null>(null);

  useEffect(() => {
    setNow(new Date());
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!now) {
    return (
      <div className="text-sm text-muted-foreground">Loading IST…</div>
    );
  }

  return (
    <div className="space-y-1">
      <p className="font-mono text-2xl font-semibold tracking-tight text-foreground">
        {formatIST(now, "h:mm:ss a")}
      </p>
      <p className="text-sm text-muted-foreground">
        {formatIST(now, "EEEE, d MMMM yyyy")} · IST
      </p>
      <p className="text-xs text-muted-foreground">
        Morning absent finalized at {MORNING_FINALIZE_HOUR}:00 AM
      </p>
    </div>
  );
}
